// Permission actions (Enterprise-specific)
export enum AccessControlAction {
  ReportingAdminCreate = 'reports.admin:create',
  ReportingAdminWrite = 'reports.admin:write',
  ReportingDelete = 'reports:delete',
  ReportingRead = 'reports:read',
  ReportingSend = 'reports:send',
  ReportingSettingsWrite = 'reports.settings:write',
  ReportingSettingsRead = 'reports.settings:read',
}
